import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const SmsTerms = () => {
    return (
        <section className="privacy-policy-page">
            <div className="about-card privacy-policy-inner">
                <h1>SMS Terms & Conditions</h1>
                <p className="About-subtitle">Effective Date: April 2026</p>

                <h2>1. Program Name</h2>
                <p className="About-text">Park Pilot Valet Service Alerts.</p>

                <h2>2. Program Description</h2>
                <p className="About-text">By opting in, you agree to receive transactional text messages related to valet operations, including check-in confirmations, request/retrieval updates, and pickup notifications.</p>

                <h2>3. Message Frequency</h2>
                <p className="About-text">Message frequency varies.</p>

                <h2>4. Fees</h2>
                <p className="About-text">Message and data rates may apply.</p>

                <h2>5. Help and Opt-Out</h2>
                <p className="About-text">
                    <strong>Reply HELP for help. Reply STOP to opt out.</strong>
                </p>

                <h2>6. Privacy Policy</h2>
                <p className="About-text">
                    See our SMS Privacy Policy: <Link to="/privacy-sms-policy">/privacy-sms-policy</Link>.
                </p>

                <h2>7. Carrier Disclaimer</h2>
                <p className="About-text">Carriers are not liable for delayed or undelivered messages.</p>

                <h2>8. Contact</h2>
                <p className="About-text">Support: parkpilotvalet@gmail.com</p>

                <p className="About-text">
                    <Link to="/">Back to Home</Link>
                </p>
            </div>
        </section>
    );
};

export default SmsTerms;
